import { useRouter } from "next/router"
import { useCallback } from "react"

/*
 * Router based hooks for handling more complex data filters
 * Basically only applied on projects data atm
 */

const supportedDataFilters = ["market-sector"] as const

type DataFilterType = (typeof supportedDataFilters)[number]

interface FilterableData {
  market_sectors?: string[]
}

export const useApplyDataFilters = () => {
  const { query } = useRouter()

  return useCallback(
    <T extends FilterableData>(data: T[]) => {
      // Valid keys to filter by
      const keys = Object.keys(query).filter((k): k is DataFilterType =>
        supportedDataFilters.includes(k as DataFilterType)
      )

      if (!keys.length) {
        return data
      }

      // TODO: Optimise this if possible. It's either once looping over ~200 items and each item in that loops for every active key or the current one
      for (const k of keys) {
        switch (k) {
          case "market-sector":
            const marketSector = query[k] as string
            if (marketSector) {
              data = data.filter((obj) =>
                obj?.market_sectors?.includes(marketSector)
              )
            }
            break
          default:
            throw "Unhandled data filter"
        }
      }
      return data
    },
    [query]
  )
}
